"use strict";

const CUSTOM_EVENTS = {
  PDP_LOAD: "custom.load_pdp",
  PDP_REVIEW_IMPRESSIONS: "custom.reviews_impression_pdp",
  SUBMIT_RATING: "custom.submit_rating",
  SUBMIT_REVIEW: "custom.submit_review",
  RATE_THIS_PRODUCT: "custom.rate_this_product",
  REVIEW_PAGE_UPLOAD_PHOTO: "custom.review_page_upload_photo",
  VIEW_ALL_REVIEWS: "custom.view_all_reviews",
  WRITE_REVIEW_ADD_MORE_PHOTO: "custom.write_review_add_more_photo",
  WRITE_REVIEW_ADD_REMOVE_PHOTO: "custom.write_review_add_remove_photo",
  REVIEWS_WITH_IMAGES_VIEW_ALL: "custom.reviews_with_images_view_all",
  REVIEWS_WITH_IMAGES_CLICK_ON_PAGE: "custom.reviews_with_images_click_on_page",
  REVIEWS_WITH_IMAGES_CLOSE_PREVIEW: "custom.reviews_with_images_close_preview",
  REVIEWS_WITH_IMAGES_PREVIEW_NEXT: "custom.reviews_with_images_preview_next",
  KNOW_MORE_RATINGS: "custom.know_more_ratings",
  REVIEWS_FILTER_APPLY: "custom.reviews_filter_apply",
  REVIEW_LIKE: "custom.review_like",
  CAMERA_ACCESS_REQUEST: "custom.camera_access_request",
  CAMERA_ACCESS_REQUEST_ACCEPTED: "custom.camera_access_request_accepted",
  CAMERA_ACCESS_REQUEST_DENIED: "custom.camera_access_request_denied",
  REVIEW_NOT_ELIGIBLE_POPUP: "custom.review_not_eligible_popup",
  POST_A_QUESTION_BUTTON_CLICK: "custom.post_a_question_button_click",
  POST_QUESTION: "custom.post_question",
  REVIEW_SUBMITTED_PAGE: "custom.review_submitted_page",
  WRITE_REVIEW_SCREEN: "custom.write_review_screen",
  EDIT_RATING: "custom.edit_rating",
  VIEW_REVIEW_IMAGES: "custom.review_section_review_images_impression"
};

export default CUSTOM_EVENTS;